/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductionFile
 */
export interface ProductionFile {
    /**
     * 
     * @type {string}
     * @memberof ProductionFile
     */
    stampedCaseFileId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionFile
     */
    parentId?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionFile
     */
    batesNumberStart?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionFile
     */
    borrowedFromSetId?: string | null;
}

export function ProductionFileFromJSON(json: any): ProductionFile {
    return ProductionFileFromJSONTyped(json, false);
}

export function ProductionFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductionFile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stampedCaseFileId': !exists(json, 'stampedCaseFileId') ? undefined : json['stampedCaseFileId'],
        'parentId': !exists(json, 'parentId') ? undefined : json['parentId'],
        'batesNumberStart': !exists(json, 'batesNumberStart') ? undefined : json['batesNumberStart'],
        'borrowedFromSetId': !exists(json, 'borrowedFromSetId') ? undefined : json['borrowedFromSetId'],
    };
}

export function ProductionFileToJSON(value?: ProductionFile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stampedCaseFileId': value.stampedCaseFileId,
        'parentId': value.parentId,
        'batesNumberStart': value.batesNumberStart,
        'borrowedFromSetId': value.borrowedFromSetId,
    };
}


